import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LoadingProvider } from "./context/LoadingContext";
import { Toaster } from "./components/ui/toaster";
import GlobalLoader from "./components/GlobalLoader";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./components/DashboardLayout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Company from "./pages/Company";
import Companies from "./pages/Companies";
import Employees from "./pages/Employees";
import EmployeeDetails from "./pages/EmployeeDetails";
import Payroll from "./pages/Payroll";
import Attendance from "./pages/Attendance";
import Reimbursements from "./pages/Reimbursements";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import Leaves from "./pages/Leaves";
import Profile from "./pages/Profile";
import Finance from "./pages/Finance";

function App() {
  return (
    <AuthProvider>
      <LoadingProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="company" element={<Company />} />
            <Route path="companies" element={<Companies />} />
            <Route path="companies/:companyId" element={<Settings />} />
            <Route path="employees" element={<Employees />} />
            <Route path="employees/:id" element={<EmployeeDetails />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="finance" element={<Finance />} />
            <Route path="attendance" element={<Attendance />} />
            <Route path="reimbursements" element={<Reimbursements />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="settings/:companyId" element={<Settings />} />
            <Route path="leaves" element={<Leaves />} />
            <Route path="profile" element={<Profile />} />
          </Route>
        </Routes>
        <Toaster />
        <GlobalLoader />
      </BrowserRouter>
      </LoadingProvider>
    </AuthProvider>
  );
}

export default App;
